/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Propuesta_Valor_Portada_Informacion = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={12}>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: sCell ? 32 : 32,
                        fontWeight: 900,
                        textAlign: sCell ? 'center' : 'flex-start',
                        width: "100%",
                        lineHeight: 1.1
                    }}>
                    {item && item.titulo && item.titulo.toUpperCase()}

                </Typography>
            </Grid2>

            <Grid2 container size={12}>
                <Typography
                    sx={{
                        textAlign: sCell ? 'center' : 'flex-start',
                        fontSize: 18,
                        color: 'white',
                        pt: 2
                    }}>
                    {item.parrafo}
                </Typography>
            </Grid2>


        </Grid2>
    )

}
export default Propuesta_Valor_Portada_Informacion;